import { type I18nLocale, t } from '@ardoq/i18n';
import { TimeFrameUnit } from './TimeFrameUnit';
import { dissectRelativeDate } from './dissectRelativeDate';
import { relativeDateLabelFormatters } from './relativeDateLabelFormatters';

const relativeDateDisplayLabel = (value: string, i18nLocale: I18nLocale) => {
  const isToday = value.match(/now[+-]0d/);
  if (isToday) {
    return t(i18nLocale, 'dateTime:today', 'Today');
  }
  const dissectedDate = dissectRelativeDate(value);
  if (!dissectedDate) {
    return false;
  }
  if (dissectedDate.value === 1 && dissectedDate.unit === TimeFrameUnit.DAY_AGO)
    return t(i18nLocale, 'dateTime:yesterday', 'Yesterday');
  if (
    dissectedDate.value === 1 &&
    dissectedDate.unit === TimeFrameUnit.DAY_FROM_NOW
  )
    return t(i18nLocale, 'dateTime:tomorrow', 'Tomorrow');
  return `${dissectedDate.value} ${relativeDateLabelFormatters[
    dissectedDate.unit
  ](dissectedDate.value)}`;
};
export { relativeDateDisplayLabel };
